import _ from 'underscore';
import { FirstPaymentDefinition } from '@ve/types';
import { MAX_PREPAYMENTS } from '@/js/common/Constants/globalParams';

type Params = {
    firstPaymentDefinitionIds: number[];
    firstPaymentDefinitionReferenceIndex: {
        [key: number]: FirstPaymentDefinition;
    };
}

export default (params: Params ): FirstPaymentDefinition[] => {
    const { firstPaymentDefinitionIds, firstPaymentDefinitionReferenceIndex } = params;    
    return _.map(firstPaymentDefinitionIds, (routeId) => firstPaymentDefinitionReferenceIndex[routeId])?.slice(0, MAX_PREPAYMENTS);
}